export enum VideoType {
    Youtube = 'youtube',
    Vimeo = 'vimeo',
    GreenVideo = 'greenVideo',
    BasicVideo = 'basicVideo',
    StreamVideo = 'streamVideo',
}
